export const applicationOperLoading = ({ applicationAccess }, instanceName: string) => {
  return applicationAccess.status[instanceName] === 'loading'
}
